// ---------------------------------------------------------------------------
// LucidTopup - ตะกร้าสินค้า (เก็บใน localStorage)
// เก็บเฉพาะ "ตัวอ้างอิง" ของรายการ (kind/itemId/packageId/inputs/qty)
// ราคา ชื่อ รูป คำนวณใหม่จากแคตตาล็อกตอนแสดงและตอนจ่ายเสมอ
// ---------------------------------------------------------------------------
const STORAGE_KEY = "lt-cart-v1";
const MAX_QTY = 99;

const read = () => {
  try {
    const rows = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    if (!Array.isArray(rows)) return [];
    // กรองข้อมูลเพี้ยน (null / ไม่ใช่ object / ขาดฟิลด์ / จำนวนไม่ใช่ตัวเลข > 0)
    return rows
      .filter(
        (row) =>
          row &&
          typeof row === "object" &&
          row.kind &&
          row.itemId !== undefined &&
          row.itemId !== null &&
          row.packageId !== undefined &&
          row.packageId !== null &&
          typeof row.key === "string" &&
          row.key &&
          Number.isFinite(Number(row.quantity)) &&
          Number(row.quantity) > 0
      )
      .map((row) => ({
        ...row,
        quantity: Math.min(MAX_QTY, Number(row.quantity)),
        inputs: row.inputs && typeof row.inputs === "object" && !Array.isArray(row.inputs) ? row.inputs : {},
      }));
  } catch (e) {
    return [];
  }
};

const write = (rows) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(rows));
  } catch (e) {
    /* localStorage ใช้ไม่ได้ (private mode / เต็ม) -> ข้าม */
  }
  window.dispatchEvent(new Event("lt-cart-change"));
};

const normalizeInputs = (inputs = {}) =>
  Object.keys(inputs)
    .sort()
    .reduce((acc, key) => ({ ...acc, [key]: String(inputs[key] ?? "").trim() }), {});

// รายการเดียวกัน = ชนิด + สินค้า + แพ็กเกจ + ข้อมูลลูกค้า (เช่น id เกม) ตรงกันทั้งหมด
const makeKey = ({ kind, itemId, packageId, inputs }) =>
  [kind, itemId, packageId, JSON.stringify(normalizeInputs(inputs))].join("|");

export const cartService = {
  list: () => read(),

  count: () => read().reduce((sum, row) => sum + (Number(row.quantity) || 0), 0),

  // รายการซ้ำ = เพิ่มจำนวน
  add: ({ kind, itemId, packageId, inputs, quantity = 1 }) => {
    const entry = { kind, itemId, packageId, inputs: normalizeInputs(inputs) };
    const key = makeKey(entry);
    const rows = read();
    const found = rows.find((row) => row.key === key);
    if (found) found.quantity = Math.min(MAX_QTY, (Number(found.quantity) || 0) + quantity);
    else rows.push({ ...entry, key, quantity: Math.min(MAX_QTY, quantity) });
    write(rows);
  },

  setQuantity: (key, quantity) => {
    write(read().map((row) => (row.key === key ? { ...row, quantity: Math.max(1, Math.min(MAX_QTY, quantity)) } : row)));
  },

  remove: (key) => write(read().filter((row) => row.key !== key)),

  clear: () => write([]),
};
